import { MapContainer, TileLayer, CircleMarker, Circle, Popup, Marker, useMap } from "react-leaflet";
import { useEffect } from "react";
import L from "leaflet";

const icon = L.divIcon({ className: "", html: '<div style="width:18px;height:18px;border-radius:50%;background:#1E3A8A;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,.35)"></div>', iconSize: [18, 18], iconAnchor: [9, 9] });

const Recenter = ({ center }) => { const m = useMap(); useEffect(() => { if (center) m.setView(center, m.getZoom()); }, [center, m]); return null; };

export const MapView = ({ center, radiusKm, points = [], height = 420, onPick, children }) => {
  const c = center || [31.9539, 35.9106];
  return (
    <MapContainer center={c} zoom={12} style={{ height, width: "100%" }} scrollWheelZoom={false} data-testid="map-view">
      <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Recenter center={center} />
      {center && <Marker position={center} icon={icon} />}
      {center && radiusKm && <Circle center={center} radius={radiusKm * 1000} pathOptions={{ color: "#06B6D4", fillOpacity: 0.06, weight: 1.5 }} />}
      {points.map((p, i) => (
        <CircleMarker key={p.id || i} center={[p.lat, p.lng]} radius={9} pathOptions={{ color: p.color || "#10B981", fillColor: p.color || "#10B981", fillOpacity: 0.85, weight: 2 }} eventHandlers={onPick ? { click: () => onPick(p) } : {}}>
          {p.label && <Popup><div className="text-sm font-semibold">{p.label}</div>{p.sub && <div className="text-xs text-slate-500">{p.sub}</div>}</Popup>}
        </CircleMarker>
      ))}
      {children}
    </MapContainer>
  );
};
